document.addEventListener("DOMContentLoaded", function() {
  const variantInputSelects = document.querySelectorAll('.variant_input_select');
  const stickyButton = document.querySelector('.sticky-atc-button-main');

  variantInputSelects.forEach(select => {
    select.addEventListener('click', function(event) {
      event.stopPropagation();
      const menu = select.nextElementSibling;
      if (menu) {
        menu.classList.toggle('variant_input_menu-open');
        document.body.classList.toggle('no-scroll-variant');
        if (stickyButton) {
          stickyButton.classList.toggle('Atc-stick-hide');
        }
      }
    });
  });

  window.addEventListener('click', function(event) {
    const openMenu = document.querySelector('.variant_input_menu-open');
    if (event.target.matches('.close-variants-btn') && openMenu) {
      openMenu.classList.remove('variant_input_menu-open');
      document.body.classList.remove('no-scroll-variant');
      if (stickyButton && stickyButton.classList.contains('Atc-stick-hide')) {
        stickyButton.classList.remove('Atc-stick-hide');
      }
    }
  });

  const closeIcons = document.querySelectorAll('.variant-close-icon');
  closeIcons.forEach(closeIcon => {
    closeIcon.addEventListener('click', function(event) {
      const openMenu = document.querySelector('.variant_input_menu-open');
      if (document.body.classList.contains('no-scroll-variant')) {
        document.body.classList.remove('no-scroll-variant');
      }
      if (openMenu) {
        openMenu.classList.remove('variant_input_menu-open');
      }
      if (stickyButton && stickyButton.classList.contains('Atc-stick-hide')) {
        stickyButton.classList.remove('Atc-stick-hide');
      }
    });
  });

  const variantInputMenus = document.querySelectorAll('.variant_input_menu');
  variantInputMenus.forEach(menu => {
    const menuItems = menu.querySelectorAll('.var_itemiant_input_menu_item');
    menuItems.forEach(menuItem => {
      menuItem.addEventListener('click', function() {
        menuItems.forEach(opt => opt.classList.remove('active'));
        this.classList.add('active');
        const allInputs = menu.querySelectorAll('input[type="radio"]');
        allInputs.forEach(input => {
          input.checked = false;
        });
        const clickedInput = menuItem.querySelector('input');
        if (clickedInput) {
          clickedInput.checked = true;
        }
        const selectedValue = clickedInput.value;
        console.log('selectedValue', selectedValue);
        const stickVal = document.querySelector('.sticky-frm-start.d-flex');
        console.log('stickVal', stickVal);
        const stickyAtcMenuItems = stickVal ? stickVal.querySelectorAll('.sticky-atc-menu_item') : [];
        stickyAtcMenuItems.forEach(item => {
          const itemValue = item.getAttribute('value');
          if (itemValue === selectedValue) {
            console.log('Match found, clicking item:', item);
            item.click();
          }
        });
        const variantId = clickedInput.getAttribute('variant_id');
        const price = clickedInput.getAttribute('price');
        const savePrice = clickedInput.getAttribute('save-price');
        const selectedSavePrice = this.closest('new-variant-picker').querySelector('.new-price .text-success');
        const selectedPrice = this.closest('new-variant-picker').querySelector('.new-price .money');
        if (selectedPrice) {
          selectedPrice.textContent = '₹' + price;
        }
        if (selectedSavePrice) {
          selectedSavePrice.textContent = savePrice;
        }
        console.log('variant_input_option_price', selectedPrice);
        const selectedInput = menu.previousElementSibling ? menu.previousElementSibling.querySelector('.variant_input_selected') : null;
        if (selectedInput) {
          selectedInput.value = selectedValue;
          selectedInput.setAttribute('variant_id', variantId);
        }
        const productForm = document.querySelector('.product-form');
        const productFormInput = productForm ? productForm.querySelector('input[name="id"]') : null;
        if (productFormInput) {
          productFormInput.value = variantId;
        }
      });
    });
  });

  variantInputMenus.forEach(menu => {
    const checkedRadio = menu.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      const selectedValue = checkedRadio.value;
      const variantId = checkedRadio.getAttribute('variant_id');
      const selectedInput = menu.previousElementSibling ? menu.previousElementSibling.querySelector('.variant_input_selected') : null;
      if (selectedInput) {
        selectedInput.value = selectedValue;
        selectedInput.setAttribute('variant_id', variantId);
      }
    }
  });

  const variant1 = document.getElementById("variant-1");
  const variant2 = document.getElementById("variant-2");
  const variantButtonsContainer = document.querySelector(".variant-buttons");
  const stickyInput = document.getElementById("sticky-atc-1");
  const sticky2input = document.getElementById("sticky-atc-2");

  function checkAndAddClass() {
    const variant1Input = document.getElementById("variant-1");
    const variant2Input = document.getElementById("variant-2");
    const variant1NextPrice = variant1Input ? variant1Input.closest('.variant_input_option') : null;
    const variant2NextPrice = variant2Input ? variant2Input.closest('.variant_input_option') : null;
    if (variantButtonsContainer) {
      variantButtonsContainer.classList.remove("variant1-active", "variant2-active");
    }
    if (stickyInput) {
      stickyInput.classList.remove('d-none');
      stickyInput.classList.add('d-flex');
    }
    if (sticky2input) {
      sticky2input.classList.add('d-none');
      sticky2input.classList.remove('d-flex');
    }

    if (variant1 && variant1.checked) {
      if (variantButtonsContainer) {
        variantButtonsContainer.classList.add("variant1-active");
      }
      const nextElement = variant1Input ? variant1Input.closest('.variant_input_option').nextElementSibling : null;
      const variantInputSelected = nextElement ? nextElement.querySelector('.variant_input_selected') : null;
      if (variant1NextPrice) {
        const newPrice1 = variant1NextPrice.querySelector('.variant_input_option_price');
        if (newPrice1) {
          newPrice1.classList.add('new-price');
        }
      }
      if (variantInputSelected) {
        const variantId = variantInputSelected.getAttribute('variant_id');
        const productForm = document.querySelector('.product-form');
        const productFormInput = productForm ? productForm.querySelector('input[name="id"]') : null;
        if (productFormInput) {
          productFormInput.value = variantId;
        }
      }
      if (stickyInput) {
        stickyInput.classList.remove('d-none');
        stickyInput.classList.add('d-flex');
      }
    } else if (variant2 && variant2.checked) {
      if (variantButtonsContainer) {
        variantButtonsContainer.classList.add("variant2-active");
      }
      const nextElement = variant2Input ? variant2Input.closest('.variant_input_option').nextElementSibling : null;
      const variantInputSelected = nextElement ? nextElement.querySelector('.variant_input_selected') : null;

      if (variant1NextPrice) {
        const newPrice1 = variant1NextPrice.querySelector('.variant_input_option_price');
        if (newPrice1) {
          newPrice1.classList.remove('new-price');
        }
      }

      if (variant2NextPrice) {
        const newPrice2 = variant2NextPrice.querySelector('.variant_input_option_price');
        if (newPrice2) {
          newPrice2.classList.add('new-price');
        }
      }

      if (variantInputSelected) {
        const variantId = variantInputSelected.getAttribute('variant_id');
        const productForm = document.querySelector('.product-form');
        const productFormInput = productForm ? productForm.querySelector('input[name="id"]') : null;
        if (productFormInput) {
          productFormInput.value = variantId;
        }
      }

      if (sticky2input) {
        sticky2input.classList.remove('d-none');
        sticky2input.classList.add('d-flex');
      }

      if (stickyInput) {
        stickyInput.classList.add('d-none');
        stickyInput.classList.remove('d-flex');
      }
    }
  }

  if (variant1) {
    variant1.addEventListener("change", checkAndAddClass);
  }
  if (variant2) {
    variant2.addEventListener("change", checkAndAddClass);
  }

  checkAndAddClass();

  const variantInputOption = document.querySelector('.variant_input_selected');
  const checkedInput = variantInputOption ? variantInputOption.getAttribute('variant_id') : null;
  if (checkedInput) {
    const productForm = document.querySelector('.product-form');
    const productFormInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    if (productFormInput) {
      productFormInput.value = checkedInput;
    }
  }
});
